import ComponentManager from '@/Management/ComponentManager';
import GenericObject from '@/Model/GenericObject';
import ControlFactory from '@/Factories/ControlFactory';

import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import Label from '@/Controls/Label';

import ChipsHelper from '@/Utility/ChipsHelper';

export default class ChipsLabelControlFactory extends ControlFactory {
    private controlDomElement: JQuery;

    public viewModel: LabelViewModel;
    public control: Label;

    constructor(params: any) {
        super(params);
    }

    public getControl(): JQuery {
        if (this.controlDomElement != null) {
            return this.controlDomElement;
        }

        this.viewModel = new LabelViewModel({
                factory: this,
                isRequired: this.isRequired,
                isEnabled: this.isEnabled,
                invalidationText: this.invalidationText,
                isValid: this.isValid,
                placeholder: '-',
                caption: this.defineComputed(() => {
                    const value = this.getGenericObject().getValue(this.detailViewItem.name);
                    return ChipsHelper.getValuesAsLabel(value, '\r\n');
                }),
                parentLocator: this.locator,
                tooltip: new LabelViewModel({
                    ergName: this.detailViewItem.tooltip
                }),
                locator: this.detailViewItem.name
            });
        this.control = new Label(this.viewModel);

        let tuple = this.control.getTuple();
        this.controlDomElement = tuple.control;

        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.controlDomElement;
    }


    private getGenericObject(): GenericObject {
        let context = this.context;
        let genericObject = context.genericObject;

        return genericObject;
    }
}

ComponentManager.setFactory('ChipsLabel', ChipsLabelControlFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');